import { Stack } from '@mui/material';
import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Accordion } from '@/modules/common/components/Accordion';
import { InfoText } from '@common/components/InfoText';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { OrderProfileButton, OrderProfilePanel } from '@/modules/orderProfile';
import { useOrderProfileStore } from '@/modules/orderProfile/store/useOrderProfileStore';

import { ActiveFlow } from './ActiveFlow';
import { AllLayoutFlows } from './AllLayoutFlows';

const FlowsPanelComponent = () => {
  const { t } = useTranslation('interface');
  const panelRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const activeModule = useAppStore((state) => state.activeModule);
  const selectedIds = useAppStore((state) => state.selectedIds);
  const orderProfile = useOrderProfileStore((state) => state.orderProfile);
  const flows = useFloorplanDesignStore((state) => state.design.flows.flows);
  const layoutFlowsAmount = useMemo(() => flows.length, [flows.length]);

  const displayCount = useMemo(() => {
    if (selectedIds.length === 0) {
      return layoutFlowsAmount;
    }
    return selectedIds.filter((id) => flows.some((f) => f.id === id)).length;
  }, [flows, layoutFlowsAmount, selectedIds]);

  useEffect(() => {
    // plz fix me
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (activeModule !== 'canvas_simulation') setOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeModule]);

  useEffect(() => {
    // plz fix me
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderProfile]);

  return (
    <>
      <OrderProfilePanel
        anchor={panelRef}
      />
      <Accordion
        ref={panelRef}
        title={t('properties.flows.header', { count: displayCount })}
        afterIcon={<OrderProfileButton />}
        key='layout'
        expanded={open}
        onChange={(expanded: boolean) => setOpen(expanded)}
        sx={{ px: 2 }}
      >
        <Stack>
          <Stack
            flex='1 1 auto'
            sx={{
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            <AllLayoutFlows />
            <ActiveFlow />

            {!layoutFlowsAmount && (
              <InfoText
                header={t('properties.flows.no_flows.title')}
                subHeader={t('properties.flows.no_flows.subtitle')}
                sx={{ width: '90%', margin: '0 auto' }}
              />
            )}
          </Stack>
        </Stack>
      </Accordion>
    </>
  );
};

export const FlowsPanel = memo(FlowsPanelComponent);
